export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/edit.85c5b8c2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};